import { CLIENT_MARKER_COLOR } from '@apps/web/features/coverage/model/map_colors';

const CLIENT_STAR_PATH =
    'm12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01Z';

export function clientStarImage(color = CLIENT_MARKER_COLOR): ImageData {
    const canvas = document.createElement('canvas');
    canvas.width = 48;
    canvas.height = 48;
    const context = canvas.getContext('2d');
    if (!context) {
        throw new Error('Cannot draw client marker');
    }
    context.scale(2, 2);
    context.fillStyle = color;
    const star = new Path2D(CLIENT_STAR_PATH);
    context.fill(star);
    return context.getImageData(0, 0, 48, 48);
}

export function potentialClientPinElement(
    color = CLIENT_MARKER_COLOR,
): HTMLElement {
    const element = document.createElement('div');
    element.innerHTML =
        '<svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true">' +
        `<path d="${CLIENT_STAR_PATH}" fill="${color}"/>` +
        '</svg>';
    element.style.filter = 'drop-shadow(0 2px 3px rgb(0 0 0 / 0.3))';
    return element;
}
